export default __webpack_public_path__ + "static/media/no-report.8285596a.png";